export default "__VITE_ASSET__CL_MDuUX__"